var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"BtnClose",attrs:{"to":_vm.to}},[_c('font-awesome-icon',{attrs:{"icon":['fal', 'times-circle']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }